<router-outlet></router-outlet>

<footer class="tw-text-center tw-my-12">
  <environment-selector></environment-selector>

  <div bitTypography="body2">Folkwang Vault</div>
  <div bitTypography="body2">{{ version }}</div>
  <br />
  <div bitTypography="helper" id="vw-disclaimer">
    Der Folkwang Vault wird mit Vaultwarden betrieben und nutzt eine angepasste Version des Bitwarden&reg; Web-Vaults.<br />
    Bei Fragen oder Problemen wenden Sie sich bitte an <a href="mailto:servicedesk@folkwang-uni.de">servicedesk&#64;folkwang-uni.de</a>
  </div>
</footer>
